import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';
import TeamSection from '../element/TeamSection';
import WithUs from '../components/WithUs';
import TestimonialBlog from '../components/TestimonialBlog';
import TouchStart from '../components/TouchStart';
import AccordionBlog from '../components/AccordionBlog';

const Team = () => {
    const { t } = useTranslation();
    return (
        <>
            <PageBanner parentPage={t('teamPage.parentPage')} activePage={t('teamPage.activePage')} motherMenu={t('teamPage.motherMenu')} />
            <section className="main-team">
                <TeamSection />
            </section>            
            <section className="main-with-us">
                <WithUs />
            </section> 
            <section className="main-testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('teamPage.testimonialSubtitle')}</span>
                                <h2 className="h2-title">{t('teamPage.testimonialTitle')}</h2>
                            </div>
                        </div>
                    </div>
                    <TestimonialBlog /> 
                </div>
            </section>            
            <section className="main-contact page-inner-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>

            {/* FAQ Section Start */}
            <section className="main-faq-content" style={{ background: '#ffffff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('home.faqSubtitle')}</span>
                                <h2 className="h2-title">{t('home.faqTitle')}</h2>
                            </div>
                            <div className="faq-accordion accordion-style">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <AccordionBlog arrayData={[
                                            { title: t('faqPage.q7'), content: t('faqPage.a7') },
                                            { title: t('faqPage.q3'), content: t('faqPage.a3') },
                                            { title: t('faqPage.q6'), content: t('faqPage.a6') },
                                            { title: t('faqPage.q11'), content: t('faqPage.a11') },
                                            { title: t('faqPage.q13'), content: t('faqPage.a13') },
                                            { title: t('faqPage.q1'), content: t('faqPage.a1') },
                                        ]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Team;